@switch (approvalActionId) {
  @case (1) {
  <sabis-ngx-dialog scTitle="Approval">
    <div modal-body>
      <div class="sc-form">
        <span>Are you sure you want to approve this hiring request ? (this operation cannot be undone)</span>
      </div>
    </div>
    <div modal-footer>
      <div>
        <!-- Approve -->
        <sabis-ngx-button (click)="onApproveClick()" scColor="warning">
          Approve
        </sabis-ngx-button>
        <!-- reject -->
        <sabis-ngx-button (click)="onCancelClick()" scColor="warning">
          Cancel
        </sabis-ngx-button>
      </div>
    </div>
  </sabis-ngx-dialog>
}

  @case (2) {
  <sabis-ngx-dialog scTitle="Rejection" class="sc-full-height">
    <div modal-body>
      <sca-card-view cardTitle="Reject">
        <div class="sc-form">
          <span>Reason to reject this hiring request.</span>
          <div class="sc-form-row">
            <sabis-texteditor2 [(ngModel)]="reason" name="reason" required
            maxlength="4000" [scMaxLength]="4000" scLabel="Please set the reason why this hiring request will be rejected"></sabis-texteditor2>
          </div>
        </div>
      </sca-card-view>
    </div>
    <div modal-footer>
      <div>
        <!-- Approve -->
        <sabis-ngx-button (click)="onRejectClick()" scColor="warning" >
          Reject
        </sabis-ngx-button>
        <!-- reject -->
        <sabis-ngx-button (click)="onCancelClick()" scColor="warning">
          Cancel
        </sabis-ngx-button>
      </div>
    </div>
  </sabis-ngx-dialog>
}
}
